/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

export default {

  vinNo(state: { vinNo: string }): string {
    return state.vinNo;
  },
  serialNo(state: { serialNo: string }): string {
    return state.serialNo;
  },
  workPattern(state: { workPattern: string }): string {
    return state.workPattern;
  },
};
